var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterMobileBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 462,
    viewBox: "0 0 375 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375 461.78L375 -0.000199709C369.526 2.90101 362.591 5.91289 354.983 9.21745C332.776 18.8622 304.829 31 290.707 50.156C280.449 64.0697 275.268 78.8624 270.288 93.0829C262.791 114.49 255.748 134.6 232.524 148.462C212.91 160.171 198.378 161.804 184.55 163.359C171.128 164.867 158.369 166.302 142.268 176.801C114.133 195.148 105.949 221.669 97.6606 248.53C96.3191 252.877 94.9749 257.233 93.5429 261.565C83.2632 292.662 69.0773 317.489 33.5097 337.301C13.3185 348.548 -3.82498 347.025 -20.1022 345.58C-32.4979 344.479 -44.3912 343.423 -56.7457 348.085C-85.3232 358.868 -103.827 382.442 -115.957 405.012C-126.806 425.199 -145.591 452.626 -164 461.78L375 461.78Z",
    fill: "url(#paint0_linear_2090_41)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2090_41",
    x1: 105.207,
    y1: 454.625,
    x2: 105.207,
    y2: 0.000028655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465282"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMobileBackground);
export default __webpack_public_path__ + "static/media/footerMobileBackground.b74fb1bbbfe9aedfbb5f104baf20ff65.svg";
export { ForwardRef as ReactComponent };